export default (props) => (
  <svg {...props} viewBox="0 0 120 120" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="m0 0h120v120h-120z" />
      <path
        d="m70.0817135 13c.8054146 0 1.5715406.308 2.1384177.8594667l20.8958772 20.2810666c.5668772.5485334.8839916 1.2965334.8839916 2.0738667v59.8810667c0 2.7074666-2.2618959 4.9045333-5.0485741 4.9045333h-57.8944328c-2.7922909 0-5.0569931-2.1970667-5.0569931-4.9045333v-78.1909334c0-2.7104 2.2647022-4.9045333 5.0569931-4.9045333zm-2.5787297 6.7692308h-32.7666213c-1.0692089 0-1.9363625.8301333-1.9363625 1.8597333v70.7402667c0 1.0296.8671536 1.8597333 1.9363625 1.8597333h51.1732904c1.0720152 0 1.9363625-.8301333 1.9363625-1.8597333v-52.7765334c0-.792-.670711-1.4373333-1.4985762-1.4373333h-14.3290825c-1.652924 0-2.9943461-1.2877333-2.9971525-2.8717333l-.0196442-14.08c-.0028063-.7949334-.6735174-1.4344-1.4985762-1.4344z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <circle
        cx="90"
        cy="90"
        fill="#FD4329"
        r="19.5"
        stroke="#fff"
        strokeWidth="3"
      />
      <g fill="#fff" fillRule="nonzero" transform="translate(88 78)">
        <path d="m1.14151129 13.5985462c.27477919 1.0669628 2.22021589 1.0694241 2.49813542.0024612l1.16035329-11.71936242c0-1.03865818-1.07399411-1.88164498-2.39921492-1.88164498-1.3252208 0-2.40078508.8429868-2.40078508 1.88164498z" />
        <path d="m2.23814464 19.2c-1.23478791 0-2.23814464 1.0743455-2.23814464 2.4s1.00335673 2.4 2.23814464 2.4h.32371072c1.23625267 0 2.23814464-1.0743455 2.23814464-2.4s-1.00189197-2.4-2.23814464-2.4z" />
      </g>
    </g>
  </svg>
);
